import React from 'react';
import { useRouter } from 'next/router';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import CenteredContainer from 'components/CenteredContainer';

import EventTicketActionButton from './components/EventTicketActionButton';
import { useEventPageContext } from './context/EventPageContext';
import RoleBasedActionBar from './components/RoleBasedActionBar';

const HostActions: React.FC = () => {
  const { event, setIsTicketModalOpen, toggleCheckout, priceRangeNoDiscount } =
    useEventPageContext();
  const { push } = useRouter();

  const goToEventDashboard = () => {
    push(`/events/${event._id}/dashboard`);
  };

  return (
    <div className="w-full fixed left-0 bottom-0 bg-white pb-8 z-50 md:pb-4 shadow-primary-50 shadow-top md:shadow-none">
      <div className="md:w-[630px] md:mx-auto flex items-center justify-between pt-4 px-4">
        <div className="w-full fixed left-0 bottom-0 z-50">
          {event.isOrganizer && (
            <CenteredContainer>
              <div className="flex justify-end pb-2">
                <Button
                  rounded
                  type={ButtonType.Primary}
                  onClick={goToEventDashboard}
                >
                  <img src="/img/icons/chart-bar-line.svg" />
                </Button>
              </div>
            </CenteredContainer>
          )}
          <EventTicketActionButton
            event={event}
            priceRangeNoDiscount={priceRangeNoDiscount}
            setIsTicketModalOpen={setIsTicketModalOpen}
            toggleCheckout={toggleCheckout}
          />
          <RoleBasedActionBar />
        </div>
      </div>
    </div>
  );
};

export default HostActions;
